"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefaultTargetingExpression = void 0;
const config_result_1 = require("../generated/cdp/cof/config_result");
/** Checks if the targeting expression is the proto default. */
function isDefaultTargetingExpression(targetingExpression) {
    return (targetingExpression.operator ===
        config_result_1.ClientTargetingExpression_Operator.UNKNOWN_OPERATOR &&
        targetingExpression.predicateOperator ===
            config_result_1.ClientTargetingExpression_PredicateOperator.UNKNOWN_PREDICATE_OPERATOR &&
        targetingExpression.property ===
            config_result_1.ClientTargetingExpression_Property.UNKNOWN_PROPERTY);
}
exports.isDefaultTargetingExpression = isDefaultTargetingExpression;
//# sourceMappingURL=util.js.map